/* Sticky Add to Cart — Clarity Labs
   Three states, driven by the real Shopify cart:
     A  not in cart  -> [ Add to cart ]
     B  in cart      -> [ price | - n + | View cart ]
     C  sold out     -> [ Sold out ] (disabled)

   The bar is ALWAYS visible - it is the only buy UI on the page now that the
   in-page Add to cart has been removed. Nothing is gated on scroll position.

   Add proxies the theme's own button when present, else posts to /cart/add.js.
   View cart opens GoKwik's KwikCart. Quantity edits go to /cart/change.js then
   fire the theme's own 'cart-drawer:refresh'.

   There is deliberately NO Buy now. GoKwik's buy-now replaces the whole cart
   with just this product, and building its checkout from the product form
   takes seconds. Add to cart -> View cart -> KwikCart's Checkout is both
   faster and non-destructive. */
(function () {
  'use strict';

  var bar = document.querySelector('[data-satc]');
  var dataEl = document.querySelector('[data-satc-data]');
  if (!bar || !dataEl || window.__clStickyAtc) return;
  window.__clStickyAtc = true;

  var DATA;
  try { DATA = JSON.parse(dataEl.textContent); } catch (e) { return; }

  /* The ceiling is the variant's REAL remaining stock. MAX_QTY is only the
     backstop for variants Shopify reports no usable number for (untracked).
     Continue-selling variants still report inventory_quantity, so they get
     their real figure too. */
  var MAX_QTY = 99;

  var $ = function (s, c) { return (c || document).querySelector(s); };

  var priceEl  = $('[data-satc-price]', bar);
  var cmpEl    = $('[data-satc-compare]', bar);
  var cartWrap = $('[data-satc-cart]', bar);
  var qtyEl    = $('[data-satc-qty]', bar);
  var minusBt  = $('[data-satc-minus]', bar);
  var plusBt   = $('[data-satc-plus]', bar);
  var addBt    = $('[data-satc-add]', bar);
  var labelEl  = $('[data-satc-label]', bar);
  var viewBt   = $('[data-satc-view]', bar);
  var noteEl   = $('[data-satc-note]', bar);

  var vid = String(DATA.selected);
  var cartQty = 0;      /* quantity of this variant's cart line */
  var lineKey = null;   /* line item key - the id /cart/change.js wants */
  var busy = false;
  var noteTimer = null;
  var soldNoted = false;

  /* ---------------------------------------------------------------
     theme controls — always resolved through the MAIN product form.
     A bare querySelector for [name="quantity"] or [name="id"] returns
     the first match in DOM order, which on this page can belong to the
     AOV bundle app or a recommended-product block.
  --------------------------------------------------------------- */
  function realAtcWrap() { return document.querySelector('.wt-product__add-to-cart'); }
  function realAtcButton() {
    var w = realAtcWrap();
    if (w) {
      var b = w.querySelector('button[name="add"],.js-add-to-cart,button[type="submit"]');
      if (b) return b;
    }
    return document.querySelector('product-form button[name="add"]');
  }
  function mainForm() {
    var b = realAtcButton();
    if (b) {
      if (b.form) return b.form;
      var fid = b.getAttribute('form');
      if (fid) { var f = document.getElementById(fid); if (f) return f; }
      var c = b.closest ? b.closest('form') : null;
      if (c) return c;
    }
    var w = realAtcWrap();
    if (w) { var f2 = w.querySelector('form[action*="/cart/add"]'); if (f2) return f2; }
    return document.querySelector('form[action*="/cart/add"]');
  }
  function realQtyInput() {
    var f = mainForm();
    if (f) { var q = f.querySelector('input[name="quantity"]'); if (q) return q; }
    var w = realAtcWrap();
    return w ? w.querySelector('input[name="quantity"]') : null;
  }
  /* The page's Add to cart button may have been removed. mainForm() then falls
     back to the first form[action*="/cart/add"] on the page, which can belong
     to the AOV bundle app - a different product entirely. So only trust a
     form-supplied id if it is one of OUR variants. */
  function currentVariantId() {
    var f = mainForm();
    if (f) {
      var i = f.querySelector('[name="id"]');
      if (i && i.value && DATA.variants[String(i.value)]) return i.value;
    }
    return vid;
  }

  /* ---------------------------------------------------------------
     hide while a drawer or modal owns the screen - but ONLY one the
     customer can actually see.

     Verified 21 Sept: tapping "+ ADD" on an upsell card makes the theme
     "open" its own cart drawer - setting cart-drawer[open],
     .wt-cart__drawer--open and body.page-overlay-cart-on - on a drawer that
     GoKwik keeps permanently at display:none / 0x0. Nothing ever closes that
     invisible drawer, so matching on the markers alone hid this bar until
     the page was reloaded. Each candidate must now be genuinely rendered.
     body.page-overlay-cart-on is dropped: <body> is always "visible", so it
     can never tell a real drawer from a ghost one - the drawer itself does.
  --------------------------------------------------------------- */
  var BLOCKERS = [
    '.wt-cart__drawer--open', 'cart-drawer[open]',
    '.wt-drawer-search--active', '.menu-drawer-overlay.active',
    '.wt__quick-buy--page-overlay--open', '.product-media-modal[open]', '.pswp--open'
  ];
  function isShown(el) {
    try {
      var c = getComputedStyle(el);
      if (c.display === 'none' || c.visibility === 'hidden' || parseFloat(c.opacity) === 0) return false;
      var r = el.getBoundingClientRect();
      return r.width > 0 && r.height > 0;
    } catch (e) { return false; }
  }
  function refreshBlocked() {
    var blocked = false;
    try {
      for (var i = 0; i < BLOCKERS.length && !blocked; i++) {
        var els = document.querySelectorAll(BLOCKERS[i]);
        for (var j = 0; j < els.length; j++) {
          if (isShown(els[j])) { blocked = true; break; }
        }
      }
    } catch (e) {}
    bar.style.visibility = blocked ? 'hidden' : '';
    bar.style.pointerEvents = blocked ? 'none' : '';
  }
  var blockRaf = null;
  function queueBlocked() {
    if (blockRaf) return;
    blockRaf = requestAnimationFrame(function () { blockRaf = null; refreshBlocked(); });
  }

  /* --------------------------------------------------------------- */
  function variant() { return DATA.variants[vid] || null; }

  function ceiling() {
    var v = variant();
    if (!v) return MAX_QTY;
    var n = typeof v.inv === 'number' ? v.inv : null;
    if (v.tracked && n !== null) {
      /* continue-selling stock can legitimately be 0 or negative; never
         return < 1 for a variant Shopify still reports as available */
      if (n < 1) return v.available ? MAX_QTY : 0;
      return n;
    }
    return MAX_QTY;
  }

  function note(msg) {
    if (!noteEl) return;
    clearTimeout(noteTimer);
    if (!msg) { noteEl.hidden = true; noteEl.textContent = ''; broadcastHeight(); return; }
    noteEl.textContent = msg;
    noteEl.hidden = false;
    broadcastHeight();
    noteTimer = setTimeout(function () {
      noteEl.hidden = true; noteEl.textContent = ''; broadcastHeight();
    }, 4000);
  }

  /* --------------------------------------------------------------- */
  function paint() {
    var v = variant();
    if (!v) return;

    var sold = !v.available;
    /* in-cart wins over sold-out: if a product sells out while it is sitting
       in someone's cart, gating the stepper on !sold would remove the only
       control they have to take it back out. */
    var inCart = cartQty > 0;

    bar.classList.toggle('is-sold', sold);
    bar.classList.toggle('is-cart', inCart);
    bar.classList.toggle('is-add', !inCart && !sold);
    bar.classList.toggle('is-last', cartQty === 1);

    if (priceEl) priceEl.textContent = v.price || '';
    if (cmpEl) {
      if (v.hasCompare && v.compare) { cmpEl.textContent = v.compare; cmpEl.hidden = false; }
      else cmpEl.hidden = true;
    }

    if (cartWrap) cartWrap.hidden = !inCart;
    if (addBt) {
      addBt.hidden = inCart;
      addBt.disabled = sold || busy;
      if (labelEl) labelEl.textContent = sold ? 'Sold out' : 'Add to cart';
    }

    if (qtyEl) qtyEl.textContent = cartQty;
    if (plusBt) plusBt.disabled = busy || cartQty >= ceiling();
    if (minusBt) minusBt.disabled = busy;
    if (viewBt) viewBt.disabled = busy;

    /* paint() runs on every sync (visibility change, pageshow, drawer close),
       so this has to fire on the TRANSITION into the state, not on every
       repaint - otherwise the note re-shows itself indefinitely. */
    if (sold && inCart) {
      if (!soldNoted) { soldNoted = true; note('Sold out - remove it to continue'); }
    } else {
      soldNoted = false;
    }

    broadcastHeight();
  }

  /* ---------------------------------------------------------------
     cart state — the single source of truth
  --------------------------------------------------------------- */
  /* Reads that started before the newest write must not overwrite it. Every
     write bumps this; a read carrying an older token is discarded. */
  var cartSeq = 0;

  function applyCart(cart) {
    if (!cart || !cart.items) return null;
    var want = String(currentVariantId());
    var qty = 0, key = null;
    for (var i = 0; i < cart.items.length; i++) {
      var it = cart.items[i];
      if (String(it.variant_id) === want) {
        /* bind the displayed quantity to the SAME line we write to. Summing
           every line while only ever changing the first made the stepper
           appear stuck when an app created a second line for the same
           variant. This bar controls one line. */
        if (key === null) { key = it.key; qty = it.quantity; }
      }
    }
    cartQty = qty;
    lineKey = key;
    return cart;
  }

  function readCart() {
    var token = cartSeq;
    /* no-store is load-bearing: without it the browser can serve a /cart.js
       from BEFORE the write we just made, and painting that stale value snaps
       the quantity back to where it was. The theme's own cart-sticky-bar.js
       passes the same flag for the same reason. */
    return fetch('/cart.js', {
      headers: { Accept: 'application/json' },
      credentials: 'same-origin',
      cache: 'no-store'
    })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cart) {
        if (token !== cartSeq) return null;   /* a newer write has landed */
        return applyCart(cart);
      })
      .catch(function () { return null; });
  }

  function syncAndPaint() { return readCart().then(paint); }

  /* tell the theme to re-render the header cart count */
  var selfAnnounced = false;
  function announceCartChange() {
    selfAnnounced = true;
    document.dispatchEvent(new CustomEvent('cart-drawer:refresh', { bubbles: true }));
    if (window.publish && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartUpdate) {
      try { window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'sticky-atc' }); } catch (e) {}
    }
  }

  function setBusy(on) {
    busy = on;
    bar.classList.toggle('is-busy', on);
    if (plusBt) plusBt.disabled = on || cartQty >= ceiling();
    if (minusBt) minusBt.disabled = on;
    if (addBt) addBt.disabled = on || !(variant() && variant().available);
    if (viewBt) viewBt.disabled = on;
  }

  /* absolute quantity write; 0 removes the line */
  function changeTo(n) {
    if (busy) return;
    /* without this the stepper was silently inert whenever /cart.js had
       failed - taps did nothing at all, with no feedback */
    if (!lineKey) {
      note("Couldn't reach the cart. Try again.");
      syncAndPaint();
      return;
    }
    var cap = ceiling();
    if (n > cap) { n = cap; note('Only ' + cap + ' available'); }
    if (n < 0) n = 0;
    if (n === cartQty) return;

    setBusy(true);
    cartSeq++;                 /* invalidate any read already in flight */
    var prev = cartQty;
    var prevKey = lineKey;
    cartQty = n;               /* optimistic */
    paint();

    writeQty(prevKey, n, false)
      .then(function (cart) {
        /* /cart/change.js RETURNS the updated cart. Using it directly removes
           a whole round trip and, more importantly, the race where a second
           concurrent /cart.js read resolved last and repainted stale data. */
        applyCart(cart);
        setBusy(false);
        paint();
        announceCartChange();
        emit(n === 0 ? 'remove' : 'qty', { quantity: cartQty, variant: currentVariantId() });
      })
      .catch(function () {
        cartQty = prev;        /* roll back to the last confirmed truth */
        setBusy(false);
        note("Couldn't update. Try again.");
        syncAndPaint();
      });
  }

  /* A line key can go stale if another app rewrites the cart between our read
     and our write - Shopify then rejects the id and the quantity silently
     reverts. Re-read once for a fresh key before giving up. */
  function writeQty(key, n, isRetry) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      cache: 'no-store',
      body: JSON.stringify({ id: key, quantity: n })
    }).then(function (r) {
      if (r.ok) return r.json();
      if (isRetry) throw new Error('change failed');
      return readCart().then(function () {
        if (!lineKey || lineKey === key) throw new Error('change failed');
        return writeQty(lineKey, n, true);
      });
    });
  }

  if (minusBt) minusBt.addEventListener('click', function () { changeTo(cartQty - 1); });
  if (plusBt) plusBt.addEventListener('click', function () {
    if (cartQty >= ceiling()) { note('Only ' + ceiling() + ' available'); return; }
    changeTo(cartQty + 1);
  });

  /* ---------------------------------------------------------------
     add
  --------------------------------------------------------------- */
  function addToCart() {
    var v = variant();
    if (!v || !v.available || busy) return;
    if (ceiling() < 1) { note('Out of stock'); return; }

    var real = realAtcButton();
    if (real) {
      /* the theme disables its own button while a request is in flight;
         falling through to raw AJAX there would double-add */
      if (real.disabled) return;
      /* respect the customer's chosen quantity, but do not let it sail past
         the ceiling - without this clamp the cap applied to the stepper only */
      var cap = ceiling();
      var q = realQtyInput();
      if (q) {
        var want = parseInt(q.value, 10);
        if (want > cap) {
          q.value = cap;
          q.dispatchEvent(new Event('input', { bubbles: true }));
          q.dispatchEvent(new Event('change', { bubbles: true }));
          note('Only ' + cap + ' available');
        }
      }
      cartSeq++;
      cartQty = 1;             /* optimistic - reconciled by confirmAdd */
      paint();
      setBusy(true);
      real.click();
      confirmAdd(0);
      return;
    }

    /* No theme button on the page (the in-page block was removed), so post
       directly. Paint state B straight away - waiting for the round trip
       before changing anything is what made this feel slow. */
    var prevQty = cartQty;
    cartSeq++;
    cartQty = 1;
    paint();
    setBusy(true);
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      cache: 'no-store',
      body: JSON.stringify({ items: [{ id: Number(currentVariantId()), quantity: 1 }] })
    })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (j) { throw new Error((j && j.description) || 'add failed'); });
        return r.json();
      })
      .then(function () {
        setBusy(false);
        announceCartChange();
        emit('atc', { via: 'ajax', variant: currentVariantId() });
        return syncAndPaint();
      })
      .catch(function (err) {
        cartQty = prevQty;     /* roll back the optimistic paint */
        setBusy(false);
        note(String(err && err.message ? err.message : 'Could not add').slice(0, 90));
        syncAndPaint();
      });
  }

  /* The proxied click gives us no response, so confirm against the cart.
     Poll a few times; the theme's own request has to land first. */
  function confirmAdd(attempt) {
    var delays = [300, 500, 900, 1400];
    if (attempt >= delays.length) {
      setBusy(false);
      syncAndPaint();
      return;
    }
    setTimeout(function () {
      readCart().then(function () {
        if (cartQty > 0) {
          setBusy(false);
          paint();
          emit('atc', { via: 'proxy', variant: currentVariantId(), quantity: cartQty });
        } else {
          confirmAdd(attempt + 1);
        }
      });
    }, delays[attempt]);
  }

  if (addBt) addBt.addEventListener('click', addToCart);

  /* ---------------------------------------------------------------
     View cart

     THE CART ON THIS STORE IS GOKWIK'S KWIKCART, NOT THE THEME DRAWER.
     The GoKwik app inline-styles <cart-drawer> to display:none;width:0;height:0,
     so toggling the theme's own open classes produced a black page-overlay with
     no panel behind it. Verified 23 Aug: the theme drawer does not open on MAIN
     either, from a real trusted click. KwikCart exposes openGokwikSideCart().
  --------------------------------------------------------------- */
  function cartUrl() {
    try {
      if (window.routes && window.routes.cart_url) return window.routes.cart_url;
      if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) {
        return window.Shopify.routes.root.replace(/\/$/, '') + '/cart';
      }
    } catch (e) {}
    return '/cart';
  }
  function drawerIsOpen() {
    try {
      return !!document.querySelector('cart-drawer[open],.wt-cart__drawer--open') ||
             document.body.classList.contains('page-overlay-cart-on');
    } catch (e) { return false; }
  }
  function themeDrawerUsable(el) {
    if (!el) return false;
    try {
      var c = getComputedStyle(el);
      if (c.display === 'none' || c.visibility === 'hidden') return false;
      return el.offsetWidth > 0 || el.offsetHeight > 0;
    } catch (e) { return false; }
  }
  function stopLoading() { bar.classList.remove('is-loading'); }
  function openCart() {
    if (busy) return;
    var onCartPage = false;
    try { onCartPage = window.location.pathname === cartUrl(); } catch (e) {}
    if (onCartPage) return;

    emit('viewcart', { variant: currentVariantId() });

    /* KwikCart takes a beat to mount. Without a visible state the button
       looks dead and people tap it again. */
    bar.classList.add('is-loading');
    setTimeout(stopLoading, 2500);

    /* 1. KwikCart - the real cart */
    if (typeof window.openGokwikSideCart === 'function') {
      try {
        window.openGokwikSideCart();
        setTimeout(function () { refreshBlocked(); stopLoading(); }, 400);
        return;
      } catch (e) { stopLoading(); }
    }

    /* 2. the theme drawer, but ONLY if it is actually rendered */
    var el = document.querySelector('cart-drawer');
    var type = el ? (el.dataset ? el.dataset.cartType : null) : null;
    if (el && type !== 'page' && themeDrawerUsable(el) && !drawerIsOpen()) {
      try {
        if (typeof el.toggleDrawerClasses === 'function') el.toggleDrawerClasses();
      } catch (e) {}
      setTimeout(function () {
        refreshBlocked();
        stopLoading();
        if (!drawerIsOpen()) window.location.href = cartUrl();
      }, 300);
      return;
    }

    /* 3. the cart page */
    window.location.href = cartUrl();
  }
  if (viewBt) viewBt.addEventListener('click', openCart);

  /* --------------------------------------------------------------- */
  function emit(name, detail) {
    document.dispatchEvent(new CustomEvent('satc:' + name, { detail: detail || {}, bubbles: true }));
    if (window.dataLayer && window.dataLayer.push) {
      window.dataLayer.push({ event: 'sticky_atc_' + name, sticky_atc: detail || {} });
    }
  }

  /* --------------------------------------------------------------- */
  function applyVariant(id) {
    if (!id) return;
    vid = String(id);
    cartQty = 0;
    lineKey = null;
    soldNoted = false;
    note('');
    paint();
    syncAndPaint();
  }
  document.addEventListener('variantChangeEnd', function (e) {
    var v = e.detail && (e.detail.variant || e.detail);
    if (v && v.id) applyVariant(v.id);
  });
  if (window.subscribe && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.variantChange) {
    try {
      window.subscribe(window.PUB_SUB_EVENTS.variantChange, function (ev) {
        if (ev && ev.data && ev.data.variant) applyVariant(ev.data.variant.id);
      });
    } catch (e) {}
  }

  /* re-read whenever the cart could have changed elsewhere */
  function externalRefresh() { if (!busy) syncAndPaint(); }
  if (window.subscribe && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartUpdate) {
    try {
      window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, function (payload) {
        /* our own announceCartChange() publishes this; without the guard it
           kicked off a second concurrent read of the cart we had just written */
        if (payload && payload.source === 'sticky-atc') return;
        externalRefresh();
      });
    } catch (e) {}
  }
  document.addEventListener('cart:refresh', externalRefresh);

  /* the mutation observer was not re-running the blocker check when the drawer
     opened - verified in-browser 23 Aug, all three selectors matched while the
     bar stayed visible. The theme dispatches these two on document from
     toggleDrawerClasses(), so bind to them directly. */
  ['cartDrawerOpen', 'cartDrawerClose'].forEach(function (k) {
    var name = (window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS[k]) || k;
    document.addEventListener(name, function () {
      refreshBlocked();
      setTimeout(refreshBlocked, 350);
    });
  });
  /* skip the echo of our own dispatch - we already syncAndPaint() after every
     write, and a second /cart.js 400ms later just made things feel laggy */
  document.addEventListener('cart-drawer:refresh', function () {
    if (selfAnnounced) { selfAnnounced = false; return; }
    setTimeout(externalRefresh, 400);
  });
  if (window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartDrawerClose) {
    document.addEventListener(window.PUB_SUB_EVENTS.cartDrawerClose, function () {
      setTimeout(externalRefresh, 120);
    });
  }
  /* bfcache: iOS restores the page without re-running scripts */
  window.addEventListener('pageshow', function (e) { if (e.persisted) externalRefresh(); });
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'visible') externalRefresh();
  });

  /* ---------------------------------------------------------------
     visibility

     Always on. The in-page Add to cart has been removed, so this bar is the
     only way to buy - there is nothing to scroll past and nothing to gate on.
     A sold-out product still shows the bar, disabled, because otherwise the
     page would carry no indication at all that it cannot be bought.
  --------------------------------------------------------------- */
  function watch() {
    bar.hidden = false;
    bar.classList.add('is-on');
    broadcastHeight();
    setTimeout(broadcastHeight, 320);

    bar.addEventListener('transitionend', function (ev) {
      if (ev.propertyName === 'transform') broadcastHeight();
    });
  }

  /* the floating video bubble stacks on top of us */
  function broadcastHeight() {
    var h = 0;
    if (bar.classList.contains('is-on') && !bar.hidden) {
      var r = bar.getBoundingClientRect();
      h = Math.max(0, Math.round(window.innerHeight - r.top));
    }
    document.documentElement.style.setProperty('--satc-height', h + 'px');
    window.dispatchEvent(new CustomEvent('satc:height', { detail: { height: h } }));
    document.dispatchEvent(new CustomEvent('satc:height', { detail: { height: h }, bubbles: true }));
  }

  /* --------------------------------------------------------------- */
  function boot() {
    paint();
    watch();
    refreshBlocked();
    broadcastHeight();
    syncAndPaint();

    try {
      new MutationObserver(queueBlocked).observe(document.body, {
        attributes: true,
        attributeFilter: ['class', 'style', 'open', 'hidden', 'aria-hidden'],
        childList: true,
        subtree: true
      });
    } catch (e) {}

    var rz;
    window.addEventListener('resize', function () {
      clearTimeout(rz);
      rz = setTimeout(broadcastHeight, 200);
    }, { passive: true });
    window.addEventListener('orientationchange', function () {
      setTimeout(broadcastHeight, 300);
    });
  }
  if (document.readyState === 'complete' || document.readyState === 'interactive') {
    setTimeout(boot, 0);
  } else {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  }
})();
